import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin, of } from 'rxjs';
import { Fonction } from 'src/app/data/intervenant/models/fonction.model';
import { FonctionsService } from 'src/app/data/intervenant/services/fonctions/fonctions.service';
import { LoaderService } from '../../../../../../../../core/services/loader/loader.service';

@Component({
    selector: 'app-edit-fonction',
    templateUrl: './edit-fonction.component.html',
    styleUrls: ['./edit-fonction.component.scss'],
    standalone: false
})
export class EditFonctionComponent implements OnInit {
    formGroup: UntypedFormGroup;
    creation = false;
    title: string;
    fonction: Fonction;

    get code() {
        return this.formGroup.get('code');
    }
    get libelle() {
        return this.formGroup.get('libelle');
    }

    constructor(
        private readonly fb: UntypedFormBuilder,
        private readonly loaderService: LoaderService,
        private readonly route: ActivatedRoute,
        private readonly router: Router,
        private readonly fonctionService: FonctionsService
    ) {}

    ngOnInit() {
        const id = parseInt(this.route.snapshot.paramMap.get('id'), 10);

        if (!id) {
            this.creation = true;
        }
        this.loadData(id);
    }

    loadData(id: number) {
        this.title = this.creation ? 'page.valeur_parametrable.form.title.add_fonction' : 'page.valeur_parametrable.form.title.edit_fonction';

        forkJoin(!this.creation ? this.fonctionService.getFonction(+id) : of(new Fonction()))
            .pipe(this.loaderService.operator())
            .subscribe(([fonction]) => {
                this.fonction = fonction;
                this.initForm(fonction.id ? fonction : null);
            });
    }

    private initForm(fonction?: Fonction): void {
        this.formGroup = this.fb.group({
            code: [{ value: fonction ? fonction.code : undefined, disabled: false }, Validators.required],
            libelle: [{ value: fonction ? fonction.libelle : undefined, disabled: false }, Validators.required]
        });
    }

    submit() {
        if (this.formGroup.valid) {
            this.fonction.code = this.code.value;
            this.fonction.libelle = this.libelle.value;

            if (this.fonction.id == null) {
                this.fonctionService.creerFonction(this.fonction).subscribe(idFonction => {
                    this.router.navigate(['.'], { relativeTo: this.route.parent });
                });
            } else {
                this.fonctionService.modifierFonction(this.fonction).subscribe(() => {
                    this.router.navigate(['.'], { relativeTo: this.route.parent });
                });
            }
        }
    }
}
